<script lang="ts">

  import httpClient from "$lib/axios-client"
  import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle,
  } from "$lib/components/ui/alert-dialog"
  import type { _response } from "$lib/data/type/_response"
  import { appStore } from "$lib/stores/app-store.svelte"
  import LoaderCircleIcon from "@lucide/svelte/icons/loader-circle"
  import { createMutation } from "@tanstack/svelte-query"
  import { toast } from "svelte-sonner"

  let { open, setOpen }: {
    open: boolean
    setOpen: (open: boolean) => void
  } = $props()

  const mutation = createMutation(() => ({
    mutationFn: async () => {

      const responseLogout = await httpClient.post<_response<null>>("/api/auth/logout", {
        timestamp: Date.now(),
      })
      const responseLogoutData = responseLogout.data

      if (responseLogout.status != 200) {
        throw new Error(responseLogoutData.message)
      }

      appStore.userLogout()
    },
    onError: (error: Error) => {
      toast.error("Terjadi kesalahan", {
        description: error.message
      })
    }
  }))

</script>
<AlertDialog
  open={open}
  onOpenChange={setOpen}
>
  <AlertDialogContent
    class="w-xs">
    <AlertDialogHeader>
      <AlertDialogTitle>Keluar Aplikasi</AlertDialogTitle>
      <AlertDialogDescription>
        Konfirmasi keluarkan akun dari aplikasi
      </AlertDialogDescription>
    </AlertDialogHeader>
    <AlertDialogFooter>
      <AlertDialogCancel
        disabled={mutation.isPending}>
        Batal
      </AlertDialogCancel>
      <AlertDialogAction
        class="group"
        data-loading={mutation.isPending}
        disabled={mutation.isPending}
        onclick={() => mutation.mutate()}
      >
        <span class="group-data-[loading=true]:invisible">Keluar</span>
        <LoaderCircleIcon class="group-data-[loading=true]:visible invisible absolute animate-spin"/>
      </AlertDialogAction>
    </AlertDialogFooter>
  </AlertDialogContent>
</AlertDialog>
